const VALID_TYPES_TO_RENDER = ['string', 'number', 'undefined', 'null'];
const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 50];
export { VALID_TYPES_TO_RENDER, DEFAULT_ROWS_PER_PAGE_OPTIONS };